import React from 'react';
import { useIcons } from '../../context/IconContext/IconContext';
import type { IconMapType } from '../../icon-maps/base-theme';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: keyof IconMapType;
  size?: number;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, ...props }) => {
  const { iconMap } = useIcons();

  // If iconMap isn't loaded yet, render nothing to avoid flashes
  if (!iconMap) {
    return null;
  }

  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in current icon map`);
    return null;
  }

  return <IconComponent size={size} {...props} />;
};

export default Icon;
